import { getLocationHref } from "../../../utils/js/utils.js";

let prefHref = getLocationHref();

/**
 * Detects if the page UURL (location.href) is different to what it was last time we checked
 * @returns {boolean} true means the SPA has 'navigated' to a different content / view
 */
export function detectSPANav() {
  const newHref = getLocationHref();
  const isNav = newHref !== prefHref;
  prefHref = newHref;
  return isNav;
}
